/* eslint-disable max-len */
import { Link, Typography } from '@one-thd/sui-atomic-components';
import React from 'react';

export function COMMON_SCAM() {
  return (
    <div data-testid="common-scam-content">
      <br />
      <Typography variant="body-lg" weight="bold">
        Phishing and Smishing
      </Typography>
      <br />
      <Typography variant="body-base">
        To protect yourself, it’s helpful to understand common scams and fraud scenarios. Two
        common schemes are phishing and smishing.
      </Typography>
      <br />
      <Typography variant="body-base">
        <strong>Phishing</strong> involves emails designed to trick you into giving scammers your personally
        identifiable information (PII). They may attempt to steal your passwords, account numbers,
        or Social Security numbers. They may urge you to click on malicious links or download
        harmful attachments. If they are able to obtain your PII, they could gain access to your
        email, bank, or other accounts or divert payments to accounts they control. Scammers launch
        thousands of phishing attacks like these every day with success. Some of these emails may
        appear to be from The Home Depot.
      </Typography>
      <br />
      <Typography variant="body-base">
        There are several ways to protect yourself against a phishing scheme:
        <br />
        <ul>
          <li>Never click on any links without verification from the sender that it is legitimate.
          </li>
          <li>Verify the legitimacy of websites and emails before sharing any personal or financial
            information.
          </li>
          <ul>
            <li>Look for slight misspellings or email addresses that don’t match the name of the
              company they are supposed to be from.
            </li>
          </ul>
          <li>Beware of offers that seem too good to be true, such as a free gift if you pay only
            the shipping fee.
          </li>
          <li>If you suspect fraud, call your bank and verify any account changes.</li>
          <li>Report the email to your email provider.</li>
          <li>Report to the Federal Trade Commission at:&nbsp;
            <a href="https://reportfraud.ftc.gov">
              https://reportfraud.ftc.gov
            </a>.
          </li>
          <li>Update the antivirus on your computer and use anti-spam resources available from your
            phone provider.
          </li>
        </ul>
      </Typography>
      <Typography variant="body-base">
        For more information on identity theft, online security and similar topics, visit the
        Federal Trade Commission’s site at:
      </Typography>
      <br />
      <Typography variant="body-base">
        <a
          href="https://consumer.ftc.gov/identity-theft-and-online-security"
        >https://consumer.ftc.gov/identity-theft-and-online-security
        </a>
      </Typography>
      <br />
      <Typography variant="body-base">
        <strong>Smishing</strong> involves sending Short Message Service (SMS or text) messages to
        persuade individuals to reveal personal information, passwords, and credit card numbers.
        These scammers may pose as your bank, retailer, software company, or internet service
        provider. They may provide a link or phone number urging you to respond immediately to
        avoid account lockout or interruption in service. Another method involves making a direct
        request via SMS impersonating an individual you may know, whether by stating they’re the
        person you know or appearing to contact you from that person’s phone number to purchase
        gift cards. You will be told that the requestor will be unavailable for a call to verify
        this request. Scammers may also send text messages posing as an employer enticing you with
        potential job opportunities.
      </Typography>
      <br />
      <Typography variant="body-base">
        Here&apos;s some ways you can protect yourself from a smishing text:
        <ul>
          <li>Don’t click links or return calls or texts from an unknown sender.</li>
          <li>Don’t provide any requested information to texts that you did not expect.</li>
          <li>Be cautious of any text requesting payments, including gift cards, especially if the
            sender
            says they are unavailable via phone.
          </li>
          <li>Report the text to your cell service provider through a “delete and report junk”
            button.
          </li>
          <li>Make sure your cell phone operating system has the latest software version and use
            anti-virus software.
          </li>
        </ul>
      </Typography>
      <br />
      <Typography variant="body-base">
        One of the most basic and easiest ways to protect yourself from a phishing or smishing scam
        is to not click links or return calls from an unknown sender without verifying the sender is
        legitimate. The other is to keep your anti-virus & spam protection on all your devices
        updated.
      </Typography>
      <br />
      <Typography variant="body-base">
        For additional information on smishing scams:
      </Typography>
      <Typography variant="body-base">
        <a href="https://www.fcc.gov/avoid-temptation-smishing-scams">https://www.fcc.gov/avoid-temptation-smishing-scams</a>
      </Typography>
      <br />
      <Typography variant="body-lg" weight="bold">
        Other Fraud Scenarios
      </Typography>
      <br />
      <Typography variant="body-base">
        Scammers can pose as customer service representatives who use deceptive tactics to
        extract your sensitive information or request payments through unconventional methods.
        Familiarizing yourself with the common scenarios mentioned below can help you to identify
        suspicious activity and protect yourself and your sensitive information while shopping.
      </Typography>
      <br />
      <Typography variant="body-base">
        Exercise caution as you shop online. Many times, scammers create fake websites that look
        like a legitimate retailer’s website, enticing customers with too-good-to-be-true offers.
        If a counterfeit site collects your personal details for payment information, they can use
        it for fraudulent activities or to sell you inferior products. Look for slight
        misspellings of the website address or other things that seem unusual about the website.
      </Typography>
      <br />
      <Typography variant="body-base">
        Scammers can commit fraud in store, too. They may try to return a stolen item or use
        tampered gift cards. When you purchase a gift card, be aware that scammers can replace
        legitimate cards with those that have been altered to redirect funds. If you encounter
        any suspicious activity, notify a store associate immediately.
      </Typography>
      <br />
      <Typography variant="body-base">
        Developing awareness and taking precautionary action can assist you in minimizing the
        risk of becoming a victim of fraud.
      </Typography>

    </div>
  );
}

export function PAYMENT_FRAUD() {
  return (
    <div data-testid="payment-fraud-content">
      <br />
      <Typography variant="body-base">
        If you have a <strong>charge you don’t recognize</strong> from The Home Depot on your credit card
        statement, please contact your credit card issuer to dispute the charge. You should be
        able to find the contact number for your credit card issuer on the back of your card.
        Please note that all homedepot.com transactions will show Atlanta, GA as the purchase
        location on the credit card statement no matter where the order is shipping. Additionally,
        your credit card statement may show multiple charges for different items on a single
        order. Shipping confirmation emails will show the amount charged for each individual
        shipment.
      </Typography>
      <br />
      <Typography variant="body-base">
        If you <strong>received an order confirmation email or text for an order you did not place</strong>,
        you may be able to cancel any orders that have not yet been processed within your online
        account. We also recommend changing the password to your THD myAccount or Pro Xtra
        account. When changing your password, remember to use strong and complex passwords, and
        don’t use the same password on multiple websites. Don’t share your passwords with others.
        Go to the Security & Password page at&nbsp;
        <a
          href="https://www.homedepot.com/myaccount/security"
        >https://www.homedepot.com/myaccount/security
        </a>
        &nbsp;to see your login activity, review your device activity, and manage your account
        authentication preferences.
      </Typography>
      <br />
      <Typography variant="body-base">
        If you&nbsp;
        <strong>
          received a message that your account information was changed and you did not make the change
        </strong>, we recommend reviewing your account information online and changing the
        password to your THD myAccount or Pro Xtra account. To protect your information, do not
        share your password and use unique passwords for all of your online accounts. Go to the
        Security & Password page at&nbsp;
        <a
          href="https://www.homedepot.com/myaccount/security"
        >https://www.homedepot.com/myaccount/security
        </a>
        &nbsp;to see your login activity, review your device activity, and manage your account
        authentication preferences.
      </Typography>
      <br />
      <Typography variant="body-base">
        If you are <strong>receiving a payment error message at checkout when shopping online</strong>,
        please verify that you provided the correct billing address and card security code (if
        applicable) for your payment method and re-submit your order. If you continue to receive
        this message, please contact your card issuer for assistance.
      </Typography>
    </div>
  );
}

export function BRUSHING_SCAMS() {
  return (
    <>
      <br />
      <Typography variant="body-base">
        Brushing is a scam that occurs when a person receives packages containing items they did not
        order. Sometimes, the senders are sellers from online platforms that ship out small
        inexpensive items to create positive but fraudulent reviews to boost their ratings. They can
        write reviews in your name and use these fake purchases with the goal of increasing their
        sales.
      </Typography>
      <br />
      <Typography variant="body-base">
        Scammers could use items they purchased from The Home Depot to perpetrate this scheme.
      </Typography>
      <br />
      <Typography variant="body-base">
        If you receive items that you didn’t order, first confirm that the item was not a gift that
        was sent to you. Check with friends and family to see if they may have sent the package.
      </Typography>
      <br />
      <Typography variant="body-base">
        <strong>What to do if you receive items that you did not order:</strong>
        <br />
        <ul>
          <li>Don’t pay for anything. Sometimes, senders follow up with a phone call.</li>
          <li className="list-disc">
            Return to the sender. If you can identify the sender, you might want to check for false
            reviews in your name and ask for them to be removed. (In some cases, there is no return
            address on the package).
          </li>
          <li>
            Check your Home Depot account for recent orders. In some cases, multiple unordered
            packages may be sent to the same address.
          </li>
          <li>
            Notify The Home Depot by calling&nbsp;
            <a href="tel:18004663337">
              1-800-HOME-DEPOT (1-800-466-3337)
            </a>
            &nbsp;if you received a package that appears
            to be from The Home Depot that you did not order and was not sent to you as a gift.
          </li>
          <li>
            Notify authorities if items are suspicious (unknown substances or liquid).
          </li>
          <li>
            Change passwords/review credit cards and financial accounts for any unauthorized
            charges.
          </li>
          <li>
            To protect yourself and your identity while shopping online, make sure you are using a
            secure site.
          </li>
        </ul>
      </Typography>
      <br />
      <Typography variant="body-base">
        The Home Depot has received reports of customers receiving packages they did not order.
        In most cases, customers are offered the options of returning, keeping, donating or
        discarding the item.
      </Typography>
      <br />
      <Typography variant="body-lg" color="brand" weight="bold">
        Relevant Links:
      </Typography>
      <Typography variant="body-base">
        <Link
          href="https://consumer.ftc.gov/consumer-alerts/2020/08/getting-unordered-seeds-and-stuff-mail"
        >Federal Trade Commission (FTC) - How to Handle Brushing Scams
        </Link>
        <br />
        <br />
        <Link
          href="https://www.uspis.gov/news/scam-article/brushing-scam"
        >U.S. Postal Inspection Service (USPIS) - Brushing Scam Overview
        </Link>
        <br />
        <br />
        <Link
          href="https://www.bbb.org/article/news-releases/20509-amazon-brushing-scam-indicates-a-serious-problem-for-victims"
        >Better Business Bureau (BBB) - Impact of Brushing Scams
        </Link>
      </Typography>
    </>
  );
}

export const COMMON_SCAM_TITLE = 'Common Scam & Fraud Scenarios';

export const PAYMENT_FRAUD_TITLE = 'Payment Fraud Concerns';

export const GIFT_CARD_TITLE = 'Common Gift Card Scams';

export const BRUSHING_SCAMS_TITLE = 'Brushing Scams';

export const COMMON_SCAM_IMAGE_RESOURCE = '/privacy-and-security-common-scams.jpeg';

export const PAYMENT_FRAUD_IMAGE_RESOURCE = '/privacy-and-security-payment-frauds.jpg';

export const BRUSHING_SCAMS_IMAGE_RESOURCE = '/privacy-and-security-brushing-scams.jpeg';

export const USER_HAS_OPTED_OUT_PREVIOUSLY = 'Your Opt-Out request has been honored.';

export const USER_HAS_NOT_OPTED_OUT_PREVIOUSLY = 'No Opt-Out request has been detected.';
